'use client'

import { BarChart3, Brain, Clock, Compass, ShieldCheck } from 'lucide-react'
import React from 'react'

const marqueeItems = [
  { icon: Clock, label: '1.2M+ Vagas indexadas' },
  { icon: ShieldCheck, label: 'Verificadas por IA' },
  { icon: Compass, label: '50+ fontes integradas' },
  { icon: BarChart3, label: 'Busca em tempo real' },
  { icon: Brain, label: 'Contextualização inteligente' },
]

export function TopMarquee() {
  return (
    <div className="w-full bg-slate-900 border-b border-white/5 py-2 overflow-hidden relative z-[60]">
      <div className="flex w-max animate-marquee whitespace-nowrap items-center">
        {[0, 1, 2, 3].map((groupIdx) => (
          <div key={groupIdx} className="flex items-center flex-shrink-0">
            {marqueeItems.map((item) => (
              <div key={item.label} className="flex items-center gap-2 mx-6 md:mx-10">
                <item.icon className="h-3.5 w-3.5 text-blue-300 flex-shrink-0" />
                <span className="text-[11px] md:text-xs font-bold text-white/95 tracking-wide uppercase drop-shadow-[0_1px_2px_rgba(0,0,0,0.5)]">
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}
